import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsDeleteApiKeyCacheKeys: AllRouteEndpoints[] = [
  "/app_settings/api_settings_info_datatable(/:app_group_id)",
];
